import { useCallback } from 'react';
import { useRouter } from 'next/router.js';
import stringify from 'qs-stringify';
export var RETURN_HREF_QUERY_PARAM = '_UCR_return_href';
/**
 * During contextual routing browser URL will be controlled by Next Router's "as" prop
 * while the page actually rendered is defined by Next Router's "href" prop.
 *
 * During contextual navigation Next Router's behaves as follows:
 * router.asPath:   /item/3               reflects current URL and updates at each page change
 * router.pathname: /search/[terms]       stay the same as long as initial page doesn't change
 * router.query:    {"terms": "foo-bar"}  same as above
 */
export function useContextualRouting() {
    var router = useRouter();
    var returnHrefQueryParam = typeof router.query[RETURN_HREF_QUERY_PARAM] === 'string'
        ? router.query[RETURN_HREF_QUERY_PARAM]
        : undefined;
    var watchedQuery = Object.assign({}, router.query);
    delete watchedQuery[RETURN_HREF_QUERY_PARAM];
    /*
     * After a page refresh there is no RETURN_HREF_QUERY_PARAM in router.query
     * RETURN_HREF_QUERY_PARAM is only available in those history entries where
     * contextual navigation is enabled (or WAS enabled in case history.back() is triggered)
     */
    var returnHref = returnHrefQueryParam !== null && returnHrefQueryParam !== void 0 ? returnHrefQueryParam : router.asPath;
    // @NOTE JSON.stringify might be replaced with any hashing solution
    var queryHash = JSON.stringify(watchedQuery);
    var makeContextualHref = useCallback(function (extraParams) {
        var _a;
        return router.pathname +
            '?' +
            stringify(Object.assign({}, router.query, extraParams, (_a = {},
                _a[RETURN_HREF_QUERY_PARAM] = returnHref,
                _a)));
    }, [queryHash, returnHref]);
    return { returnHref: returnHref, makeContextualHref: makeContextualHref };
}
